import {
  providerRequestsTyped,
  UpdateProviderProfilePayload,
} from "@/api/(requests)/providerTyped";
import type { UUID } from "@/core/types";

export async function updateProviderProfile({
  body,
  providerId,
}: {
  body: UpdateProviderProfilePayload;
  providerId?: UUID;
}): Promise<void> {
  return providerRequestsTyped.update_profile({
    body,
    searchParams: { provider_id: providerId },
  });
}
